<template>
  <div class="dialog-merchant-info-supply-wrapper">
    <el-dialog title="补全商户资料" width="70%" :visible="visible" @close="onDialogClose">
      <div class="dialog-upload-img">
        <div class="upload-img-form">
          <div class="upload-img-block">
            <h3>上传租赁合同照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: supplyingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onHetongUploadSuccess"
              :on-error="onImgUploadFailed">
              <img v-if="hetong.url" :src="hetong.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(hetong.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>

          <div class="upload-img-block">
            <h3>上传门店照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: supplyingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onMendianUploadSuccess" >
              <img v-if="mendian.url" :src="mendian.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(mendian.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>

          <div class="upload-img-block">
            <h3>上传室内照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: supplyingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onShineiUploadSuccess" >
              <img v-if="shinei.url" :src="shinei.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(shinei.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>
          <div class="upload-img-block">
            <h3>上传收银台照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: supplyingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onShouyintaiUploadSuccess" >
              <img v-if="shouyintai.url" :src="shouyintai.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(shouyintai.url)">预览</el-button>
            <el-button
              type="danger"
              size="medium"
              v-if="false"
              style="margin-top: 1rem">选择图片</el-button>
          </div>
        </div>

        <div class="submit-wrapper">
          <el-button
            type="danger"
            size="medium"
            @click="onImgUploadSubmit">保存</el-button>
          <el-button
            size="medium"
            @click="onImgUploadCancel">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="imgPreivewDialogViesible">
      <img width="100%" :src="imgPreviewUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DialogMerchantInfoSupply',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    supplyingMerchant: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imgPreivewDialogViesible: false,
      imgPreviewUrl: '',

      hetong: {
        url: '',
        filename: ''
      },
      shinei: {
        url: '',
        filename: ''
      },
      mendian: {
        url: '',
        filename: ''
      },
      shouyintai: {
        url: '',
        filename: ''
      }
    }
  },
  methods: {
    ...mapActions('bank', [
      'completeMerchantInfo'
    ]),

    onDialogClose () {
      this.$emit('update:visible', false)
    },

    beforeUpload (file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error('只能上传图片格式！')
      }
      if (!isLt2M) {
        this.$message.error('上传的图像不能大于 2MB ！')
      }
      return isImg && isLt2M
    },

    onHetongUploadSuccess (res, file, fileList) {
      this.hetong.url = res.data.url
      this.hetong.filename = res.data.filename
    },
    onMendianUploadSuccess (res, file, fileList) {
      this.mendian.url = res.data.url
      this.mendian.filename = res.data.filename
    },
    onShineiUploadSuccess (res, file, fileList) {
      this.shinei.url = res.data.url
      this.shinei.filename = res.data.filename
    },
    onShouyintaiUploadSuccess (res, file, fileList) {
      this.shouyintai.url = res.data.url
      this.shouyintai.filename = res.data.filename
    },
    onImgPreview (url) {
      if (url === '') {
        this.$message({
          type: 'error',
          message: '请先上传图片'
        })
        return
      }
      this.imgPreviewUrl = url
      this.imgPreivewDialogViesible = true
    },
    onImgUploadFailed (err) {
      console.log(err)
      this.$message({
        type: 'error',
        message: '上传失败'
      })
    },
    onImgUploadCancel () {
      this.resetImgUploadForm()
      this.$emit('update:visible', false)
    },
    async onImgUploadSubmit () {
      if (this.hetong.filename === '' || this.mendian.filename === '' ||
        this.shinei.filename === '' || this.shouyintai.filename === '') {
        this.$message({
          type: 'error',
          message: '请先上传完所有图片'
        })
        return
      }

      // 如果已补全的无需再补全
      if ('complete_status' in this.supplyingMerchant &&
        this.supplyingMerchant.complete_status === 1) {
        this.$message({
          type: 'error',
          message: '资料已补全，无需重复补全'
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: `正在上传图片，请稍等...`,
        spinner: 'el-icon-loading',
        background: 'rbga(0, 0, 0, 0.8)'
      })

      try {
        await this.completeMerchantInfo({
          merchantId: this.supplyingMerchant.merchant_id,
          hetong: this.hetong.filename,
          shinei: this.shinei.filename,
          mendian: this.mendian.filename,
          shouyintai: this.shouyintai.filename
        })

        this.visible = false
        this.$message({
          type: 'success',
          message: '资料补全成功'
        })
        this.$emit('data-change')
        this.resetImgUploadForm()
        this.$nextTick(() => {
          loading.close()
        })
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '资料补全失败'
        })
        this.$nextTick(() => {
          loading.close()
        })
      }
    },
    resetImgUploadForm () {
      this.shinei.url = ''
      this.shinei.filename = ''
      this.mendian.url = ''
      this.mendian.filename = ''
      this.hetong.url = ''
      this.hetong.filename = ''
      this.shouyintai.url = ''
      this.shouyintai.filename = ''
    },
    getJWT () {
      const userInfo = JSON.parse(localStorage.getItem('user_info'))
      if (userInfo === null) {
        return {}
      }

      return {
        'x-access-token': userInfo.token,
        'secret': userInfo.secret
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-merchant-info-supply-wrapper {

  .dialog-upload-img {

    .upload-img-form {
      display: flex;
      justify-content: space-around;
      flex-flow: row nowrap;
      align-items: center;
      text-align: center;

      .img-uploader {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409EFF;
        }
        .uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
        }
        img {
          width: 178px;
          height: 178px;
          display: block;
        }
      }
    }

    .submit-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 18%;
      margin: 2rem auto 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/bank/DialogMerchantInfoSupply.vue